import React, { useRef } from "react";
import "./Contact.css";
import { HiOutlineMail } from "react-icons/hi";
import emailjs from "emailjs-com";

const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_og2bagq",
                "template_nuseu1j",
                form.current,
                "VyXw7Pb13kTIwFNtN"
            )
            .then(
                (result) => {
                    console.log(result.text);
                },
                (error) => {
                    console.log(error.text);
                }
            );
        e.target.reset();
    };

    return (
        <section id="contact">
            <div className="container title__container title__contact">
                <h5>Get In Touch</h5>
                <h2>Contact Me</h2>
            </div>
            <div className="container contact__container  ">
                <div className="contact__options">
                    <article className="contact__option">
                        <HiOutlineMail className="contact__option-icon" />
                        <h4>Email</h4>
                        <h5>sinyavskiy.d@gmail.com</h5>
                        <a href="mailto:sinyavskiy.d@gmail.com" target="_blank">
                            Send a message
                        </a>
                    </article>
                    <article className="contact__option">
                        <HiOutlineMail className="contact__option-icon" />
                        <h4>Telegram</h4>
                        <h5>+358451600610</h5>
                        <a
                            href="https://telegram.me/+358451600610"
                            target="_blank"
                        >
                            Send a message
                        </a>
                    </article>
                    <article className="contact__option">
                        <HiOutlineMail className="contact__option-icon" />
                        <h4>WhatsApp</h4>
                        <h5>+358451600610</h5>
                        <a href=" https://wa.me/+358451600610" target="_blank">
                            Send a message
                        </a>
                    </article>
                </div>
                <form ref={form} onSubmit={sendEmail}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Your Full Name"
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        required
                    />
                    <textarea
                        name="message"
                        rows="7"
                        placeholder="Your Message"
                        required
                    ></textarea>
                    <button
                        type="submit"
                        className="btn btn-primary contact-btn"
                    >
                        Send Message
                    </button>
                </form>
            </div>
        </section>
    );
};

export default Contact;
